import React from "react";
import ContextualLinks from "@components/countryPage/CityCard/ContextualLinks/contextualLinks";
import styles from "./cityCard.module.scss";
import { RichText } from "prismic-reactjs";
import htmlSerializer from "@utils/htmlSerializer/htmlSerializer";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";
import LocalizedExternalLink from "@components/LocalizedExternalLink/localizedExternalLink";

const CityCard = ({ name, cityImage, cityDescription, slug, locale }) => {
  return (
    <div className={styles.cityCard} key={slug}>
      <li>
        <LocalizedExternalLink url={`${process.env.HOMEPAGE_URL}`} path={`/accommodation/${slug}`} locale={locale} title={name}>
          <Imgix
            className="lazyload"
            src={cityImage.url}
            alt={cityImage.alt ? cityImage.alt : name}
            sizes='(min-width: 36em) 500px, 90vw'
            imgixParams={{ auto: 'compress,format' }}
            attributeConfig={{
              src: 'data-src',
              srcSet: 'data-srcset',
              sizes: 'data-sizes',
            }}
            htmlAttributes={{
              src: buildURL(cityImage.url, { auto: 'compress,format', blur: 50, w: 120 }),
            }}
          />
          <h4>{name}</h4>
        </LocalizedExternalLink>
      </li>
      <div className={styles.cityCard__description}>
        {cityDescription && (
          <RichText render={cityDescription} htmlSerializer={htmlSerializer} />
        )}
      </div>
      <ContextualLinks city={slug} locale={locale} />
    </div>
  );
};

export default CityCard;
